import React from 'react'

export const breakpoints = {
  lg: {
    breakpoint: 'lg',
  },
  md: {
    breakpoint: 'md',
  },
  sm: {
    breakpoint: 'sm',
  },
  xs: {
    breakpoint: 'xs',
  },
}

export const WindowSizeContext = React.createContext(
  breakpoints.xs // default value
)
